import React from "react";
import { useMediaQuery } from "react-responsive";

import DesktopView from "./DesktopView/Desktop";
import TabletView from "./TabletView/Tablet";

function Section5() {
	const isDesktopOrLaptop = useMediaQuery({
		query: "(min-device-width: 1025px)",
	});
	const isTablet = useMediaQuery({ query: "(max-width: 1024px)" });

	if (isDesktopOrLaptop) {
		return <DesktopView />;
	} else if (isTablet) {
		return <TabletView />;
	}
}

export default Section5;